<div class="document-row"
  (click)="goToDocumentChat()"
  >
  <span class="document-name">{{ 'budget' | human }} #{{ document().correlative_id }}</span>
  <span class="document-state">
    {{ document().status.name }}
  </span>
</div>
